export const FETCH_CLASS = "FETCH_CLASS";
export const FETCH_CLASS_REQUEST = "FETCH_CLASS_REQUEST";
export const FETCH_CLASS_SUCCESS = "FETCH_CLASS_SUCCESS";
export const FETCH_CLASS_FAILURE = "FETCH_CLASS_FAILURE";
